import { getOptimizedImage } from "@/helpers"
import { normalizeImageUrl } from "@/common/helpers/imageUrl.helper"

/**
 * Decorates any podcast or episode object with a `logo` property:
 * an optimized, cache-busted 170×170 thumbnail URL, or `false` when no image is set.
 */
export const withLogo = (item) => ({
  ...item,
  logo: item.image?.length
    ? getOptimizedImage(normalizeImageUrl(item.image) + "?u=" + Date.now(), 170, 170)
    : false,
})

